import t from 'react-translate';
import CollapsiblePanel from 'athena/components/collapsible-panel';
import { PanelStateKey } from 'athena/components/constants';
import { css } from '@emotion/react';
import prodPathReplace from 'shared/prod-path-rewrite';
import { threeQuartersSpacing } from 'styles/global_defaults/scaffolding';
import { gray2 } from 'styles/global_defaults/colors';
import { config } from '@config/pendo.config.json';
import VideoPreviewModal from './video-preview-modal';

type GoalSettingGuideProps = {
  videoUrl: string;
};

const styles = css`
  &.goal-setting-guide {
    background: linear-gradient(
        91.4deg,
        rgba(235, 179, 129, 0.1) 0.19%,
        rgba(153, 206, 212, 0.1) 98.6%
      ),
      #ffffff;

    .goal-setting-guide-content {
      color: ${gray2} !important;
      gap: ${threeQuartersSpacing}px;
    }
  }
`;

const GoalSettingGuide = ({ videoUrl }: GoalSettingGuideProps) => {
  const translationBase = t.MENTORING_PROGRAMS.PARTICIPANT_HOME.GOALS.GOAL_SETTING_GUIDE;

  const panelTitle = translationBase.TITLE();

  return (
    <CollapsiblePanel
      css={styles}
      isNested
      iconSize='smallest'
      title={panelTitle}
      panelState={{
        persistState: true,
        localStorageKey: PanelStateKey.GOAL_SETTING_GUIDE_STATE,
      }}
      ariaLabel={panelTitle}
      className='goal-setting-guide py-3 px-4'
      dataQa={config.pendo.athena.mentorshipProgram.participantHome.goals.settingGuide.panel}
    >
      <div className='text-body goal-setting-guide-content mt-3 d-flex align-items-center'>
        <VideoPreviewModal
          videoSrc={videoUrl}
          thumbnailSrc={prodPathReplace(
            'images/goal-setting-guide-preview.svg',
          )}
          title={translationBase.MODAL.TITLE()}
          ariaLabel={translationBase.ARIA_LABEL.PLAY_GOAL_SETTING_GUIDE()}
          width={142}
          height={80}
          dataQa={config.pendo.athena.mentorshipProgram.participantHome.goals.settingGuide.video}
        />
        <div>{translationBase.TEXT()}</div>
      </div>
    </CollapsiblePanel>
  );
};

export default GoalSettingGuide;
